import React, { useState } from "react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Card, CardContent } from "../ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../ui/table";
import { PlusIcon, TrashIcon, SearchIcon } from "lucide-react";
import { format } from "date-fns";
import { de } from "date-fns/locale";

export function ArchiveTable({ 
  archivedTasks,
  onRestoreTask,
  onDeleteTask
}) {
  const [archiveSearchTerm, setArchiveSearchTerm] = useState('');

  // Filter archived tasks based on search term
  const getFilteredArchivedTasks = () => {
    if (!archiveSearchTerm.trim()) {
      return archivedTasks;
    }
    const searchLower = archiveSearchTerm.toLowerCase().trim();
    return archivedTasks.filter(task => 
      task.title?.toLowerCase().includes(searchLower) ||
      task.work_instruction?.toLowerCase().includes(searchLower) ||
      task.article_number?.toLowerCase().includes(searchLower)
    );
  };

  return (
    <div className="space-y-4">
      {/* Header */}
      <div className="space-y-4">
        <h2 className="text-2xl font-bold text-gray-900">Aufgaben-Archiv</h2>
        
        {/* Archive Search */}
        <div className="flex justify-center">
          <div className="relative max-w-2xl w-full">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <SearchIcon className="h-5 w-5 text-gray-400" />
            </div>
            <Input
              type="text"
              placeholder="Archiv suchen (Auftrag, Bezeichnung, Artikelnummer)..."
              value={archiveSearchTerm}
              onChange={(e) => setArchiveSearchTerm(e.target.value)}
              className="pl-10 w-full"
            />
            {archiveSearchTerm && (
              <button
                onClick={() => setArchiveSearchTerm('')}
                className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
              >
                ×
              </button>
            )}
          </div>
        </div>

        <p className="text-center text-gray-600">Wiederkehrende Aufgaben-Vorlagen</p>
      </div>

      {/* Archive Table */}
      <Card>
        <CardContent className="p-0">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Auftrag</TableHead>
                <TableHead>Bezeichnung</TableHead>
                <TableHead>Artikelnummer</TableHead>
                <TableHead>Sollstückzahl</TableHead>
                <TableHead>Archiviert am</TableHead>
                <TableHead>Aktionen</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {getFilteredArchivedTasks().map((task) => (
                <TableRow key={`archived-${task.id}`}>
                  <TableCell className="font-medium">{task.title}</TableCell>
                  <TableCell>{task.work_instruction}</TableCell>
                  <TableCell>{task.article_number || '-'}</TableCell>
                  <TableCell>{task.target_quantity}</TableCell>
                  <TableCell>
                    {task.archived_at ? format(new Date(task.archived_at), "PPP", { locale: de }) : '-'}
                  </TableCell>
                  <TableCell>
                    <div className="flex space-x-2">
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => onRestoreTask(task.id)}
                        className="text-green-600 hover:text-green-700 hover:bg-green-50"
                      >
                        <PlusIcon className="h-4 w-4 mr-1" />
                        Neue Aufgabe erstellen
                      </Button>
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => onDeleteTask(task.id)}
                        className="text-red-600 hover:text-red-700 hover:bg-red-50"
                      >
                        <TrashIcon className="h-4 w-4" />
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
              {archivedTasks.length === 0 && (
                <TableRow>
                  <TableCell colSpan={6} className="text-center py-8 text-gray-500">
                    Keine archivierten Aufgaben vorhanden
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}

export default ArchiveTable;
